export const PRODUCT_FACET_ORDER = [
  'product_category_taxonomy_term_term_parents',
  'certificates_media_certificate_type',
  'multiplex_kit',
  'field_product_test_targets',
  'testing_method',
];

export const REMOTE_LOCATION_NODE = '134041';